/**
 * Routes categories to appropriate mini-game based on mechanic type
 */
export class DeepDiveRouter {
    constructor() {
        this.mechanicComponents = {};
    }

    /**
     * Load and instantiate appropriate mini-game
     * @param {Object} category - Category with deepDive data
     * @param {Function} onComplete - Callback when mini-game completes
     * @returns {Object} Mini-game instance
     */
    loadMiniGame(category, onComplete = null) {
        const mechanic = category.deepDive.mechanic;

        if (!mechanic) {
            throw new Error('No mechanic specified in deepDive data');
        }

        const GameComponent = this.mechanicComponents[mechanic];

        if (!GameComponent) {
            throw new Error(`Unknown mechanic: ${mechanic}`);
        }

        return new GameComponent(category.deepDive, category.answer, onComplete, category);
    }

    /**
     * Register a mini-game component
     * @param {string} mechanic - Mechanic identifier
     * @param {Class} component - Mini-game class
     */
    registerMechanic(mechanic, component) {
        this.mechanicComponents[mechanic] = component;
    }
}
